import { Component } from '@angular/core'

@Component({
  selector: 'app-required-asterisk',
  templateUrl: './required-asterisk.component.html',
  styleUrls: ['./required-asterisk.component.scss'],
})
export class RequiredAsteriskComponent {}
